"use strict";
/*
 * Copyright 2020 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LockHashUtils = void 0;

var js_sha256_1 = require("js-sha256");

var js_sha3_1 = require("js-sha3");

var ripemd160 = require("ripemd160");

var LockHashAlgorithm_1 = require("../../model/lock/LockHashAlgorithm");
/**
 * Hash utilities for SecretLock hashing
 */


var LockHashUtils = /*#__PURE__*/function () {
  function LockHashUtils() {
    _classCallCheck(this, LockHashUtils);
  }

  _createClass(LockHashUtils, null, [{
    key: "Op_Sha3_256",
    value:
    /**
     * Perform SHA3_256 hash
     * @param input buffer to be hashed
     * @returns {string} Hash in hexidecimal format
     */
    function Op_Sha3_256(input) {
      return js_sha3_1.sha3_256.create().update(input).hex().toUpperCase();
    }
    /**
     * Perform SHA256 hash
     * @param input buffer to be hashed
     * @returns {string} Hash in hexidecimal format
     */

  }, {
    key: "Op_Hash_256",
    value: function Op_Hash_256(input) {
      var hash = js_sha256_1.sha256(input);
      return js_sha256_1.sha256(Buffer.from(hash, 'hex')).toUpperCase();
    }
    /**
     * Perform ripemd160 hash
     * @param input buffer to be hashed
     * @returns {string} Hash in hexidecimal format
     */

  }, {
    key: "Op_Hash_160",
    value: function Op_Hash_160(input) {
      var sha256Hash = js_sha256_1.sha256(input);
      return new ripemd160().update(Buffer.from(sha256Hash, 'hex')).digest('hex').toUpperCase();
    }
    /**
     * Perform hash for SecretLock with proficed hash algorithm
     * @param hashAlgorithm Hash algorithm
     * @param input buffer to be hashed
     * @returns {string} Hash in hexidecimal format
     */

  }, {
    key: "Hash",
    value: function Hash(hashAlgorithm, input) {
      switch (hashAlgorithm) {
        case LockHashAlgorithm_1.LockHashAlgorithm.Op_Hash_160:
          return LockHashUtils.Op_Hash_160(input);

        case LockHashAlgorithm_1.LockHashAlgorithm.Op_Hash_256:
          return LockHashUtils.Op_Hash_256(input);

        case LockHashAlgorithm_1.LockHashAlgorithm.Op_Sha3_256:
          return LockHashUtils.Op_Sha3_256(input);

        default:
          throw new Error('HashAlgorithm is invalid.');
      }
    }
  }]);

  return LockHashUtils;
}();

exports.LockHashUtils = LockHashUtils;